"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledScreenReaderSpan = exports.ScreenReaderOnlyCss = exports.FocusCss = exports.BorderRadiusCss = void 0;
Object.defineProperty(exports, "borderRadiusConfig", {
  enumerable: true,
  get: function get() {
    return _stylesConfig.borderRadiusConfig;
  }
});
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _stylesConfig = require("./stylesConfig");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var BorderRadiusCss = exports.BorderRadiusCss = function BorderRadiusCss() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 's';
  return "border-radius: ".concat(_stylesConfig.borderRadiusConfig === null || _stylesConfig.borderRadiusConfig === void 0 ? void 0 : _stylesConfig.borderRadiusConfig[size]);
};
var FocusCss = exports.FocusCss = "\n\toutline: var(--spacing-global-space1) solid var(--color-functional-focus);\n\toutline-offset: var(--spacing-global-space1);\n\toutline-color: var(--color-functional-focus);\n";

/**
 * The ScreenReaderOnlyCss is taken from https://webaim.org/techniques/css/invisiblecontent/
 * The purpose is to visually hide content that will be read by a screen reader.
 */
var ScreenReaderOnlyCss = exports.ScreenReaderOnlyCss = "\n\theight: 1px;\n\tleft: -10000px;\n\toverflow: hidden;\n\tposition: absolute;\n\ttop: auto;\n\twidth: 1px;\n";

/**
 * The StyledScreenReaderSpan uses the above ScreenReaderOnlyCss
 * This is taken from https://webaim.org/techniques/css/invisiblecontent/
 * The purpose is to visually hide content that will be read by a screen reader.
 */
var StyledScreenReaderSpan = exports.StyledScreenReaderSpan = _styledComponents["default"].span.attrs({
  className: "fuse-screen-reader-only"
}).withConfig({
  displayName: "styles__StyledScreenReaderSpan",
  componentId: "sc-t1z7lb-0"
})(["", ""], ScreenReaderOnlyCss);